import {
  ApiBlueprint,
  configApiRef,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { AnalyticsImplementationBlueprint } from '@backstage/plugin-app-react';
import BarChartIcon from '@material-ui/icons/BarChart';
import { BackstageAnalytics } from './BackstageAnalytics';
import { analyticsStatsApiRef, AnalyticsStatsClient } from './api';

/** Sends every analytics event of the app to our analytics backend (see docs/analytics.md). */
const backstageAnalytics = AnalyticsImplementationBlueprint.make({
  name: 'backstage',
  params: defineParams =>
    defineParams({
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ configApi, discoveryApi, fetchApi }) =>
        BackstageAnalytics.fromConfig(configApi, { discoveryApi, fetchApi }),
    }),
});

const analyticsStatsApi = ApiBlueprint.make({
  name: 'stats',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: analyticsStatsApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new AnalyticsStatsClient(discoveryApi, fetchApi),
      }),
    ),
});

const analyticsPage = PageBlueprint.make({
  name: 'analytics',
  params: {
    path: '/analytics',
    title: 'Usage analytics',
    // Without an icon, the page gets no sidebar entry (nav.take('page:analytics') in Sidebar.tsx)
    icon: <BarChartIcon fontSize="inherit" />,
    loader: () =>
      import('./components/AnalyticsPage/AnalyticsPage').then(m => (
        <m.AnalyticsPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'analytics',
  extensions: [backstageAnalytics, analyticsStatsApi, analyticsPage],
});
